import type { FunctionComponent } from 'react';
import { Video } from '../../components/video';
import type { VideoFragment } from '../../graphql/fragments/VideoFragment.graphql';
import { useGetVideo } from '../../graphql/hooks/video';
import type { VideoSourceType } from '../../types/video';
const VideoInternal: FunctionComponent<Props> = ({
  sys,
  type,
  ...restProps
}) => {
  if (restProps.files) {
    return <VideoInternalResolved sys={sys} type={type} {...restProps} />;
  }
  return <SelfFetchingVideo sys={sys} type={type} data-sentry-element="SelfFetchingVideo" data-sentry-component="VideoInternal" data-sentry-source-file="video.tsx" />;
};
const SelfFetchingVideo: FunctionComponent<Props> = ({
  sys,
  type
}) => {
  const {
    data
  } = useGetVideo({
    variables: {
      id: sys.id
    }
  });
  return <VideoInternalResolved sys={sys} type={type} {...data} data-sentry-element="VideoInternalResolved" data-sentry-component="SelfFetchingVideo" data-sentry-source-file="video.tsx" />;
};

/**
 * Renders a video, fetches the details from Contentful.
 */
const VideoInternalResolved: FunctionComponent<Props> = ({
  poster,
  files,
  alt = '',
  preset
}) => {
  if (!files) return null;
  return <Video poster={poster?.source} sources={files?.items as VideoSourceType[]} alt={alt ?? ''} preset={preset !== 'gif' ? 'video' : preset} width='100%' data-sentry-element="Video" data-sentry-component="VideoInternalResolved" data-sentry-source-file="video.tsx" />;
};
export default VideoInternal;
type Props = VideoFragment;